import { X2jOptions, XMLParser } from 'fast-xml-parser';

export class XmlParserService {
    private parser: XMLParser;

    constructor(options?: X2jOptions) {
        this.parser = new XMLParser(options);
    }

    public async parseXmlFile(xmlFile: File) {
        const xmlFileArrayBuffer = await xmlFile.arrayBuffer();

        const xmlDataBuffer = Buffer.from(xmlFileArrayBuffer);

        return this.parser.parse(xmlDataBuffer);
    }
}
